import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconI24 from '../build/icon-i24'

export const IconI24: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconI24} />
}

export default IconI24
